module.exports = __webpack_public_path__ + "static/media/comment.1b8c9753.svg";